import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import ReactToPrint from "react-to-print";
import axios from "axios";
import moment from "moment";
import Modal from '@material-ui/core/Modal';
import { Box } from '@material-ui/core';
import Button from "@material-ui/core/Button";
import swal from 'sweetalert'
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Shared/Css/IpgoPrint.css';
import { useStoresIpgo } from '../UseStores/UseStore';
import jungjinlog from '../img/coup/220130_JungJin_logo-01.png';
import IpgoPrintBox from './IpgoPrintBox';

const boxStyle = {
  position: 'absolute',
  // top: '50%',
  //left: '73.85%',
  // left: '50%',
  // transform: 'translate(-50%, -50%)',
  width: '100%',
  height: '100%',
  overflow: 'auto',
  // bgcolor: 'background.paper',
  // border: '2px solid #000',
  // borderColor: "primary.light",
  //borderColor: "red",
  //boxShadow: 24,
};

function IpgoPrint(props) {
  const [imgview, setImgview] = useState([]);

  console.log(props.ipgoprintmove)
  console.log(props.ipgoprintopen)

  const componentRef = useRef(); //react to print
  const printRef = useRef(); //react to print
  const history = useHistory();

  //zustend 스테이트 설정 가저오기
  const { ipgoprintopentrue, ipgoprintopenhangmok, ipgoprintopenquality } = useStoresIpgo();
  //console.log(ipgoprintopenhangmok)
  //console.log(ipgoprintopenquality)
  const view = ipgoprintopenhangmok.ipgo_item ? ipgoprintopenhangmok.ipgo_item : props.ipgoprintmove.ipgo_item;
  //console.log( view )
  // console.log(`주스텐드0: ${ipgoprintopenhangmok.edit}`)
  //console.log(`주스텐드1: ${ipgoprintopenhangmok.ipgo_jongjangprint}`)
  // console.log(`주스텐드1: ${ipgoprintopenhangmok.ipgo_item_auto}`)
  //console.log(`주스텐드1: ${ipgoprintopentrue}`)
  //console.log(`주스텐드3: ${ipgoprintopenvalue}`)
  //console.log(`주스텐드4: ${ipgoprintopenvalueprint}`)

  useEffect(() => {
    const imgJsonLoad = async () => {
      await axios.get(`/IpgoReact/ItemImgIndex?ItemSabun=${view}`)
        .then((res) => {
          //setImgview(res.date);
          //console.log(res.data)
          setImgview(res.data[0].file);
        })
    };
    imgJsonLoad()
  }, [view])

  return (
    <div>
      <Modal
        open={
          props.ipgoprintopen ? props.ipgoprintopen : Boolean(ipgoprintopentrue)
        }
      >
        <Box sx={boxStyle}>
          <div>
            <div className='container'>
              <Button
                className="Btn"
                variant="contained"
                style={{
                  fontSize: 24,
                  borderRadius: 0,
                  background: "#039be5",
                  color: "white",
                }}
                startIcon={
                  <i
                    className="fas fa-pen-to-square"
                    style={{ fontSize: "24px", color: "white" }}
                  ></i>
                }
                onClick={() => {
                  if (props.ipgoprintopen === true) {
                    props.setIpgoprintopen(false);
                  } else {
                    swal("조회화면에서 실행되었습니다.", {
                      button: { text: "닫기" },
                      timer: 5000,
                    });
                  }
                }}
              >
                등록이동
              </Button>
              <ReactToPrint
                content={() => componentRef.current}
                ref={printRef}
                trigger={() => (
                  <Button
                    className="Btn"
                    style={{
                      fontSize: 24,
                      borderRadius: 0,
                      background: "#00897b",
                      color: "white",
                    }}
                    startIcon={<i className="fas fa-print" style={{ fontSize: "24px", color: "white" }}></i>}
                    variant="contained"
                  >
                    인쇄
                  </Button>
                )}
              />
              <Button
                className="Btn"
                variant="contained"
                style={{
                  fontSize: 24,
                  borderRadius: 0,
                  background: "#00acc1",
                  color: "white",
                }}
                startIcon={
                  <i
                    className="fas fa-rectangle-list"
                    style={{ fontSize: "24px", color: "white" }}
                  ></i>
                }
                onClick={() => {
                  if (Boolean(ipgoprintopentrue) === true) {
                    history.goBack(); //이전페이지 이동
                  } else {
                    swal("등록화면에서 실행되었습니다.", {
                      button: { text: "닫기" },
                      timer: 5000,
                    });
                  }
                }}
              >
                조회이동
              </Button>
            </div>
            <div ref={componentRef}>
              <div className="paper">
                <div className="content">
                  {/*우리품번바코드*/}
                  <div className="printbarcodesabun">
                    {ipgoprintopentrue === true
                      ? `*${ipgoprintopenhangmok.ipgo_item_auto}*`
                      : `*${props.ipgoprintmove.ipgo_item_auto}*`}
                  </div>
                  <div>
                    <img
                      className="imgsabun"
                      src={`data:image/png;base64,${imgview}`}
                      alt="에라"
                    />
                  </div>
                  <div>
                    <img
                      className="printjungjinlog"
                      src={jungjinlog}
                      alt="정진로그"
                    />
                    <div className="printgongjung">정진공정이동전표</div>
                  </div>
                  <table className="printtable">
                    <thead></thead>
                    <tbody>
                      <tr>
                        <td colSpan="2" className="printtd-02">
                          1.작업이력현황
                        </td>
                      </tr>
                      <tr>
                        <td className="printtd-00 print--00 printfont">
                          지시번호
                        </td>
                        <td className="printtd-01 print--00 printfont">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenhangmok.ipgo_item_auto
                            : props.ipgoprintmove.ipgo_item_auto}
                        </td>
                        <td className="printtd-00 print--00">우리품번</td>
                        <td colSpan="3" className="printtd-01 print--00">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenhangmok.ipgo_item
                            : props.ipgoprintmove.ipgo_item}
                        </td>
                      </tr>
                      <tr>
                        <td className="printtd-00 print--00">제품별명</td>
                        <td className="printtd-01 print--00">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenhangmok.ipgo_item_bel_meng
                            : props.ipgoprintmove.ipgo_item_bel_meng}
                        </td>
                        <td className="printtd-00 print--00">품번</td>
                        <td
                          colSpan="3"
                          className="printtd-01 print--00 printfont"
                        >
                          {ipgoprintopentrue === true
                            ? ipgoprintopenhangmok.ipgo_item_upche_item
                            : props.ipgoprintmove.ipgo_item_upche_item}
                        </td>
                      </tr>
                      <tr>
                        <td className="printtd-00 print--00">품명</td>
                        <td className="printtd-01 print--00">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenhangmok.ipgo_item_upche_name
                            : props.ipgoprintmove.ipgo_item_upche_name}
                        </td>
                        <td className="printtd-00 print--00">업체명</td>
                        <td colSpan="3" className="printtd-01 print--00">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenhangmok.ipgo_item_upche_sangho
                            : props.ipgoprintmove.ipgo_item_upche_sangho}
                        </td>
                      </tr>
                      <tr>
                        <td className="printtd-00 print--00">입고일자</td>
                        <td className="printtd-01 print--00">
                          {ipgoprintopentrue === true
                            ? moment(
                              ipgoprintopenhangmok.ipgo_item_datetime
                            ).format("YYYYMMDD HH:mm")
                            : moment(
                              props.ipgoprintmove.ipgo_item_datetime
                            ).format("YYYYMMDD HH:mm")}
                        </td>
                        <td className="printtd-00 print--00 printfont">
                          입고수량
                        </td>
                        <td className="printtd-00 print--00 printfont">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenhangmok.ipgo_item_quantity +
                            ipgoprintopenhangmok.ipgo_item_daewi
                            : props.ipgoprintmove.ipgo_item_quantity +
                            props.ipgoprintmove.ipgo_item_daewi}
                        </td>
                        <td className="printtd-00 print--00">용기수량</td>
                        <td className="printtd-00 print--00">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenhangmok.ipgo_dangrang
                            : props.ipgoprintmove.ipgo_dangrang}
                        </td>
                      </tr>
                      <tr>
                        <td className="printtd-00 print--00">작업라인</td>
                        <td className="printtd-01 print--00">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenhangmok.ipgo_item_cheri_desc
                            : props.ipgoprintmove.ipgo_item_cheri_desc}
                        </td>
                        <td className="printtd-00 print--00">작업공정</td>
                        <td colSpan="3" className="printtd-01 print--00">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenhangmok.ipgo_최종공정라인
                            : props.ipgoprintmove.ipgo_최종공정라인}
                        </td>
                      </tr>
                      <tr>
                        <td className="printtd-00 print--00">업체전표량</td>
                        <td className="printtd-01 print--00">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenhangmok.ipgo_ticket_jundal
                            : props.ipgoprintmove.ipgo_ticket_jundal}
                        </td>
                        <td className="printtd-00 print--00">기타사항</td>
                        <td colSpan="3" className="printtd-01 print--00">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenhangmok.ipgo_item_description
                            : props.ipgoprintmove.ipgo_item_description}
                        </td>
                      </tr>
                      <tr>
                        <td className="printtd-00 print--00">작업요청일</td>
                        <td className="printtd-01 print--00"></td>
                        <td className="printtd-00 print--00">업체LOT</td>
                        <td colSpan="3" className="printtd-01 print--00">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenhangmok.ipgo_upche_lot_code
                            : props.ipgoprintmove.ipgo_upche_lot_code}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table>
                    <tbody>
                      <tr>
                        <td className="printtd-02">2.수입검사이력현황</td>
                      </tr>
                      <tr>
                        <td className="">
                          ✔수입검사 기준서 참조(와관항은 전수검사실시){"-->"}
                          이상발생시에는 해당업체에 피드백한다.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table border="1" className="printtable03">
                    <thead>
                      <tr>
                        <td rowSpan="2" className="printtd-03">
                          구분
                        </td>
                        <td
                          rowSpan="2"
                          colSpan="2"
                          className="printtd-03 print--0004"
                        >
                          검사항목/규격
                        </td>
                        <td className="printtd-03 print--0004">기록검사수</td>
                        <td colSpan="3" className="printtd-03">
                          20,000Ea
                          <br />
                          이하
                        </td>
                        <td colSpan="3" className="printtd-03">
                          20,001~
                          <br />
                          40,000Ea
                        </td>
                        <td colSpan="3" className="printtd-03">
                          40,000Ea
                          <br />
                          이상
                        </td>
                        <td rowSpan="2" className="printtd-03">
                          종합판정
                        </td>
                        <td rowSpan="2" className="printtd-03">
                          검사자
                        </td>
                        <td rowSpan="2" className="printtd-03">
                          비고
                        </td>
                      </tr>
                      <tr>
                        <td className="printtd-03">기록범례</td>
                        <td className="printtd-03">x1</td>
                        <td className="printtd-03">x2</td>
                        <td className="printtd-03">x3</td>
                        <td className="printtd-03">x4</td>
                        <td className="printtd-03">x5</td>
                        <td className="printtd-03">x6</td>
                        <td className="printtd-03">x7</td>
                        <td className="printtd-03">x8</td>
                        <td className="printtd-03">x9</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td rowSpan="5" className="printtd-03">
                          외관검사(육안)
                        </td>
                        <td rowSpan="1" className="printtd-03">
                          ㉮
                        </td>
                        <td className="printtd-03">발청(녹-RUST)</td>
                        <td className="printtd-03">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenquality.suip_insp_01
                            : props.ipgoprintmove.suip_insp_01}
                        </td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td rowSpan="5" className="printtd-03">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenhangmok.ipgo_item_qc_inspection
                            : props.ipgoprintmove.ipgo_item_qc_inspection}
                        </td>
                        <td rowSpan="5" className="printtd-03">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenhangmok.ipgo_item_qc_gumsuja
                            : props.ipgoprintmove.ipgo_item_upche_sangho}
                        </td>
                        <td rowSpan="5" className="printtd-03"></td>
                      </tr>
                      <tr>
                        <td className="printtd-03">㉯</td>
                        <td className="printtd-03">유분 및 이물질잔존</td>
                        <td className="printtd-03">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenquality.suip_insp_02
                            : props.ipgoprintmove.suip_insp_02}
                        </td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                      </tr>
                      <tr>
                        <td className="printtd-03">㉰</td>
                        <td className="printtd-03">이종품 혼입</td>
                        <td className="printtd-03">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenquality.suip_insp_03
                            : props.ipgoprintmove.suip_insp_03}
                        </td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                      </tr>
                      <tr>
                        <td className="printtd-03">㉱</td>
                        <td className="printtd-03">고객 공정누락</td>
                        <td className="printtd-03">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenquality.suip_insp_04
                            : props.ipgoprintmove.suip_insp_04}
                        </td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                      </tr>
                      <tr>
                        <td className="printtd-03">㉲</td>
                        <td className="printtd-03">변형,Burr,찍힘,크랙등</td>
                        <td className="printtd-03">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenquality.suip_insp_05
                            : props.ipgoprintmove.suip_insp_05}
                        </td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                      </tr>
                      <tr>
                        <td colSpan="3" className="printtd-03">
                          이상발생 조치사항
                        </td>
                        <td colSpan="13" className="printtd-03"></td>
                      </tr>
                    </tbody>
                  </table>
                  <table className="printtable03">
                    <tbody>
                      <tr>
                        <td className="printtd-02 ">3.생산공정현황</td>
                      </tr>
                    </tbody>
                  </table>
                  <table border="1" className="printtable03">
                    <thead>
                      <tr>
                        <td rowSpan="2" className="printtd-03">
                          순
                        </td>
                        <td rowSpan="2" colSpan="2" className="printtd-03">
                          공정명
                        </td>
                        <td rowSpan="2" className="printtd-03">
                          일자
                        </td>
                        <td colSpan="2" className="printtd-03">
                          작업
                        </td>
                        <td rowSpan="2" className="printtd-03">
                          작업라인
                        </td>
                        <td rowSpan="2" className="printtd-03">
                          합격여부
                        </td>
                        <td rowSpan="2" className="printtd-03">
                          작업자
                        </td>
                        <td rowSpan="2" className="printtd-03">
                          비고
                        </td>
                      </tr>
                      <tr>
                        <td className="printtd-03 print--0004">수량</td>
                        <td className="printtd-03">단위</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="printtd-03">1</td>
                        <td colSpan="2" className="printtd-03">
                          예비산탈지(탈지)
                        </td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenhangmok.ipgo_item_quantity
                            : props.ipgoprintmove.ipgo_item_quantity}
                        </td>
                        <td className="printtd-03">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenhangmok.ipgo_item_daewi
                            : props.ipgoprintmove.ipgo_item_daewi}
                        </td>
                        <td className="printtd-03">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenhangmok.ipgo_item_cheri_desc
                            : props.ipgoprintmove.ipgo_item_cheri_desc}
                        </td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                      </tr>
                      <tr>
                        <td className="printtd-03">2</td>
                        <td colSpan="2" className="printtd-03">
                          표면처리
                        </td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenhangmok.ipgo_item_quantity
                            : props.ipgoprintmove.ipgo_item_quantity}
                        </td>
                        <td className="printtd-03">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenhangmok.ipgo_item_daewi
                            : props.ipgoprintmove.ipgo_item_daewi}
                        </td>
                        <td className="printtd-03">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenhangmok.ipgo_item_cheri_desc
                            : props.ipgoprintmove.ipgo_item_cheri_desc}
                        </td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                      </tr>
                      <tr>
                        <td className="printtd-03">3</td>
                        <td colSpan="2" className="printtd-03">
                          검사/포장
                        </td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenhangmok.ipgo_item_quantity
                            : props.ipgoprintmove.ipgo_item_quantity}
                        </td>
                        <td className="printtd-03">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenhangmok.ipgo_item_daewi
                            : props.ipgoprintmove.ipgo_item_daewi}
                        </td>
                        <td className="printtd-03">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenhangmok.ipgo_item_cheri_desc
                            : props.ipgoprintmove.ipgo_item_cheri_desc}
                        </td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                      </tr>
                    </tbody>
                  </table>
                  <table className="printtable03">
                    <thead>
                      <tr>
                        <td className="printtd-02 ">4.완제품 최종검사</td>
                      </tr>
                    </thead>
                  </table>
                  <table border="1" className="printtable03">
                    <thead>
                      <tr>
                        <td colSpan="3" className="printtd-03">
                          샘플링수량
                        </td>
                        <td colSpan="5" className="printtd-03">
                          MIP불량
                        </td>
                        <td rowSpan="2" className="printtd-03">
                          결과
                        </td>
                        <td colSpan="2" className="printtd-03">
                          용기수량
                        </td>
                        <td rowSpan="2" className="printtd-03">
                          포장상태
                        </td>
                        <td rowSpan="2" className="printtd-03">
                          조치사항
                        </td>
                      </tr>
                      <tr>
                        <td className="printtd-03">검사수</td>
                        <td className="printtd-03">합격수</td>
                        <td className="printtd-03">불량수</td>
                        <td className="printtd-03">박리</td>
                        <td className="printtd-03">얼룩</td>
                        <td className="printtd-03">찍힘</td>
                        <td className="printtd-03">혼입</td>
                        <td className="printtd-03">기타</td>
                        <td className="printtd-03">Box</td>
                        <td className="printtd-03">PLT</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03">합 / 부</td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                        <td className="printtd-03"></td>
                      </tr>
                    </tbody>
                  </table>
                  <table className="printtable03">
                    <tbody>
                      <tr>
                        <td className="printtd-02 ">5.포장현황</td>
                      </tr>
                    </tbody>
                  </table>

                  <table border="1" className="printtable04">
                    <thead>
                      <tr>
                        <td rowSpan="2" className="printtd-04 print--0002">
                          입고수량:
                          {ipgoprintopentrue === true
                            ? ipgoprintopenhangmok.ipgo_item_quantity
                            : props.ipgoprintmove.ipgo_item_quantity}
                          {ipgoprintopentrue === true
                            ? ipgoprintopenhangmok.ipgo_item_do_danwie
                            : props.ipgoprintmove.ipgo_item_do_danwie}
                        </td>
                        <td colSpan="5" className="printtd-04 print--0003">
                          {ipgoprintopentrue === true
                            ? ipgoprintopenhangmok.ipgo_dangrang ? (
                              Number(
                                ipgoprintopenhangmok.ipgo_item_quantity
                              ) / Number(ipgoprintopenhangmok.ipgo_dangrang)
                            ).toFixed(1) + "Box" : ""
                            : props.ipgoprintmove.ipgo_dangrang ? (
                              Number(props.ipgoprintmove.ipgo_item_quantity) /
                              Number(props.ipgoprintmove.ipgo_dangrang)
                            ).toFixed(1) + "Box" : ""}
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;출고내역
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="printtd-04">출고</td>
                        <td className="printtd-04"></td>
                        <td className="printtd-04"></td>
                        <td className="printtd-04"></td>
                        <td className="printtd-04"></td>
                        <td className="printtd-04"></td>
                      </tr>
                      <tr>
                        <td className="printtd-04">잔량</td>
                        <td className="printtd-04"></td>
                        <td className="printtd-04"></td>
                        <td className="printtd-04"></td>
                        <td className="printtd-04"></td>
                        <td className="printtd-04"></td>
                      </tr>
                      <tr>
                        <td className="printtd-04">그롭No</td>
                        <td className="printtd-04"></td>
                        <td className="printtd-04"></td>
                        <td className="printtd-04"></td>
                        <td className="printtd-04"></td>
                        <td className="printtd-04"></td>
                      </tr>
                      <tr>
                        <td className="printtd-04">담당자</td>
                        <td className="printtd-04"></td>
                        <td className="printtd-04"></td>
                        <td className="printtd-04"></td>
                        <td className="printtd-04"></td>
                        <td className="printtd-04"></td>
                      </tr>
                    </tbody>
                  </table>
                  {/* 창고위치 */}
                  <div className="changgowiche">
                    {ipgoprintopentrue === true
                      ? ipgoprintopenhangmok.ipgo_wi_chi
                      : props.ipgoprintmove.ipgo_wi_chi}
                  </div>
                  <br></br>
                  <h3 style={{ textAlign: "center" }}>
                    JungJin Parker & Golbal
                  </h3>
                </div>
                {/* 바코드 */}
                <div className="printbarcodesabundown nextpage">
                  {ipgoprintopentrue === true
                    ? `*${ipgoprintopenhangmok.ipgo_item_auto}*`
                    : `*${props.ipgoprintmove.ipgo_item_auto}*`}
                </div>
                {ipgoprintopentrue === true
                  ? ipgoprintopenhangmok.ipgo_공장간이동전표출력 === "있음" ? <IpgoPrintBox /> : null
                  : props.ipgoprintmove.ipgo_공장간이동전표출력 === "있음" ? <IpgoPrintBox ipgoprintmove={props.ipgoprintmove} /> : null}
                {/* <IpgoPrintBox ipgoprintmove={props.ipgoprintmove} /> */}
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default IpgoPrint